<template>
    <svg
        class="icon-link"
        :class="iconClasses"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="currentColor"
    >
        <path
            d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-4H9q-.13 0-.25.031A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h1.535c.218-.376.495-.714.82-1z"
        />
        <path
            d="M9 5.5a3 3 0 0 0-2.83 4h1.098A2 2 0 0 1 9 6.5h3a2 2 0 1 1 0 4h-1.535a4 4 0 0 1-.82 1H12a3 3 0 1 0 0-6z"
        />
    </svg>
</template>

<script>
export default {
    name: 'IconLink',
    props: {
        size: {
            required: false,
            type: Number,
            default: 4,
        },
        marginAuto: {
            required: false,
            type: Boolean,
            default: true,
        },
    },
    computed: {
        iconClasses() {
            const cls = {};
            cls[`h-${this.size} w-${this.size}`] = true;
            cls['m-auto'] = !!this.marginAuto;
            return cls;
        },
    },
};
</script>
